import { http, refreshApi } from "./index"

export async function login(data:any) {
    return await http.post<any>('/api/auth/login/', data)
}

export async function logout() {
    return await http.post<any>('/api/auth/logout/')
}

export async function resetPassword(data:any) {
    return await http.post<any>('/api/user/password-reset/request/', data)
}

export async function confirmPassword(data:any) {
    return await http.post<any>('/api/user/password-reset/confirm/', data)
}

export async function getInfo() {
    return await http.get<any>('/api/user/me/')
}

export async function refreshAccessToken() {
    return await refreshApi.post<any>('/api/auth/refresh/')
}

export async function getMetabaseUrl(data:any) {
    return await http.get<any>('/api/metabase_url/', {
        params: {
            date_from: data.from,
            date_to: data.to,
            department_id: data.department
        }
    })
}

export async function authKeys(data:any) {
    return await http.post<any>('/api/auth-keys/', data)
}